export const defaultDirectoryId = "A352";
